import { commonTypes } from './common';

export const types = {
  GENERATE_PIN: 'OBD/GENERATE_PIN',
  VALIDATE_PIN: 'OBD/VALIDATE_PIN',
  VALIDATE_PIN_SUCCESS: 'OBD/VALIDATE_PIN_SUCCESS',
  VALIDATE_PIN_MISMATCH: 'OBD/VALIDATE_PIN_MISMATCH',
  VALIDATE_PIN_TIMED_OUT: 'OBD/VALIDATE_PIN_TIMEDOUT',
};

export const initialState = {
  validatePinLoading: false,
  validatePinMismatch: false,
  validatePinTimedOut: false,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
const OBDReducer = (state = initialState, action) => {
  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        validatePinLoading: false,
        validatePinMismatch: false,
        validatePinTimedOut: false,
      };
    }
    case commonTypes.SET_BLOCKED_BY_OBD_STATUS: {
      if (action && action.payload && action.payload.status === false) {
        return {
          validatePinLoading: false,
          validatePinMismatch: false,
          validatePinTimedOut: false,
        };
      }

      return {
        ...state,
      };
    }
    case types.GENERATE_PIN: {
      return {
        ...state,
      };
    }
    case types.VALIDATE_PIN: {
      return {
        ...state,
        validatePinLoading: true,
        validatePinTimedOut: false,
        validatePinMismatch: false,
      };
    }
    case types.VALIDATE_PIN_SUCCESS: {
      return {
        ...state,
        validatePinLoading: false,
        validatePinTimedOut: false,
        validatePinMismatch: false,
      };
    }
    case types.VALIDATE_PIN_TIMED_OUT: {
      return {
        ...state,
        validatePinLoading: false,
        validatePinTimedOut: true,
        validatePinMismatch: false,
      };
    }
    case types.VALIDATE_PIN_MISMATCH: {
      return {
        ...state,
        validatePinLoading: false,
        validatePinTimedOut: false,
        validatePinMismatch: true,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  generatePin: data => ({
    type: types.GENERATE_PIN,
    payload: data,
  }),
  validatePin: data => ({
    type: types.VALIDATE_PIN,
    payload: {
      pinToValidate: data,
    },
  }),
  validatePinSuccess: () => ({
    type: types.VALIDATE_PIN_SUCCESS,
  }),
  validatePinTimedOut: () => ({
    type: types.VALIDATE_PIN_TIMED_OUT,
  }),
  validatePinMismatch: () => ({
    type: types.VALIDATE_PIN_MISMATCH,
  }),
};

export default OBDReducer;
